// extracted by mini-css-extract-plugin
export default {"no-data-container":"NoResultAnalytics_no-data-container__aVpxa","no-data-content":"NoResultAnalytics_no-data-content__M+lP+","label":"NoResultAnalytics_label__fqxQp"};